import { useEffect } from "react";

/**
 * Hook to preload critical images for better LCP
 * @param imageUrls - Array of image URLs to preload
 * @param priority - Whether these are high priority images (default: false)
 */
export const useImagePreload = (imageUrls: string[], priority: boolean = false) => {
  useEffect(() => {
    if (!imageUrls || imageUrls.length === 0) return;

    // Preload images with high priority
    imageUrls.forEach((url) => {
      if (!url) return;
      
      const link = document.createElement("link");
      link.rel = "preload";
      link.as = "image";
      link.href = url;
      
      if (priority) {
        link.setAttribute("fetchpriority", "high");
      }
      
      document.head.appendChild(link);
    });

    // Cleanup function
    return () => {
      const links = document.head.querySelectorAll('link[rel="preload"][as="image"]');
      links.forEach((link) => {
        if (imageUrls.includes((link as HTMLLinkElement).href)) {
          document.head.removeChild(link);
        }
      });
    };
  }, [imageUrls, priority]);
};

/**
 * Hook to preload the first visible images on the homepage
 */
export const useHomepageImagePreload = (stories: any[]) => {
  const firstThreeImages = stories
    .slice(0, 3)
    .map((story) => story?.coverPhoto || story?.imgUrl)
    .filter(Boolean);

  useImagePreload(firstThreeImages, true);
};

